<template>
  <a-modal title="就诊人详情" width="100%"
           wrap-class-name="full-modal" :visible="visible" :confirmLoading="confirmLoading"
           @cancel="handleCancel"
  >
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
    </template>

    <div class="viewDetial-title">基本信息</div>
    <a-row style="height:30px">
      <a-col :span="8">
        <label>就诊人：{{ this.userDate.patientName + ' ' + (this.userDate.patientSex == 1 ? '男' : this.userDate.patientSex == 2 ? '女' : '') + ' ' + this.userDate.patientAge +' 岁' }}</label>
      </a-col>
      <a-col :span="8">
        <label>手机号：{{ this.userDate.patientMobile }}</label>
      </a-col>
      <a-col :span="8">
        <label>ID：{{ this.userDate.patientId }}</label>
      </a-col>
    </a-row>
    <a-row style="height:30px">
      <a-col :span="8">
        <label>诊断：{{ this.userDate.recentDiagnosis }}</label>
      </a-col>
      <a-col :span="8">
        <label>积分：<a>{{ this.userDate.integral }}</a> </label>
      </a-col>
      <a-col :span="8">
        <label>地址：{{ this.userDate.address }}</label>
      </a-col>
    </a-row>

    <!-- <div class="viewDetial-title">家庭成员</div>
    <div>
      <s-table ref="tables" :columns="columns" :data="loadData" :rowKey="(record) => record.mediId">
        <span slot="mediNum" slot-scope="text, record">
          {{ 'x' + record.mediNum}}
        </span>
        <span slot="freq" slot-scope="text, record">
          {{ record.freq + ',' + '一次' + record.dayNum }}
        </span>
      </s-table>
    </div> -->

    <div class="viewDetial-title">就诊信息</div>
    <div class="visitInfomation">
      <div class="visitInfomation_speed">
        <ul v-if="visitList.length > 1">
          <li v-for="(item,index) in visitList" :key="index" @click="getRegister(item.registerId , index)" :class="tabIndex == index? 'tabActive' : ''  ">
            {{ item.treatType == 0 ? '图文问诊' : item.treatType == 1 ? '健康咨询' : item.treatType == 2 ? '视频问诊' : item.treatType == 3 ? '视频问诊' : '' }}
            &nbsp;&nbsp;{{ item.ctstamp }}&nbsp;&nbsp;{{ item.deptName }}
          </li>
        </ul>
      </div>

      <div class="visitInfomation_pres">
        <div class="visitInfomation_pres_tab">
          <div v-for="(item,index) in presTab" :key="index" :class="activeIdx == index? 'activeStyle' : '' " @click="clickItem(index)">{{item}}</div>
        </div>

        <div class="visitInfomation_pres_detial">
          <div v-show="registerList.length == 0">
            <a-empty />
          </div>

          <div class="visitInfomation_pres_detial_list" v-for="(item,index) in registerList" :key="index">
            <div>
              <div style="font-size:16px;margin-bottom: 10px;font-weight: bold;">处方{{index + 1}}</div>
              <div>
                <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
                  <a-col :span="8">
                    <label>处方类型：{{ item.recipeBasicInfo.name }}</label>
                  </a-col>
                  <a-col :span="8">
                    <label>处方类别：{{ item.recipeBasicInfo.category == 1 ? '西药/中成药' : item.recipeBasicInfo.category == 2 ? '中药' : ''}}</label>
                  </a-col>
                  <a-col :span="8">
                    <label>接诊医生：{{ item.recipeBasicInfo.recDrName }}</label>
                  </a-col>
                </a-row>

                <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
                  <a-col :span="8">
                    <label>开立时间：{{ item.recipeBasicInfo.ctstamp }}</label>
                  </a-col>
                  <a-col :span="8">
                    <label>处方单号：{{ item.recipeBasicInfo.recipeNo }}</label>
                  </a-col>
                  <a-col :span="8">
                    <label>审核药师：{{ item.recipeBasicInfo.pharName }}</label>
                  </a-col>
                </a-row>
              </div>

              <div class="imitateTable">
                <div class="imitateTable_title">
                  <div style="max-width:40px">序号</div>
                  <div>药品名称</div>
                  <div style="max-width:80px">编码</div>
                  <div style="max-width:70px">用药天数</div>
                  <div>用法用量</div>
                  <div>规格</div>
                  <div style="max-width:40px">数量</div>
                  <div style="max-width:40px">单位</div>
                  <div style="max-width:60px">金额</div>
                </div>

                <div v-for="(record,index) in item.mediDetailVOList.rows" :key="index" class="imitateTable_item">
                  <div style="max-width:40px">{{index + 1}}</div>
                  <div style="text-align:left">{{ record.mediName }}</div>
                  <div style="max-width:80px;text-align:left">{{ record.mediCode }}</div>
                  <div style="max-width:70px">{{ record.dayNum }}</div>
                  <div style="color:#1890FF">
                    {{ (record.useType == null ? '' : record.useType + '，') + (record.wmOnceDosage == null ? '' : record.wmOnceDosage + record.baseUnit + '/一次，') +( record.freq == null? '' : record.freq )}}
                  </div>
                  <div>{{ record.specification }}</div>
                  <div style="max-width:40px">{{ record.mediNum }}</div>
                  <div style="max-width:40px">{{ record.packageUnit }}</div>
                  <div style="max-width:60px;text-align:right">{{ record.unitPrice }}</div>
                </div>

                <div class="imitateTable_total">
                  <div style="max-width:40px"></div>
                  <div style="text-align:left">总计</div>
                  <div style="max-width:80px"></div>
                  <div style="max-width:70px"></div>
                  <div></div>
                  <div></div>
                  <div style="max-width:40px">{{ item.recipeBasicInfo.totalCount }}</div>
                  <div style="max-width:40px"></div>
                  <div style="max-width:60px;text-align:right">{{ item.recipeBasicInfo.totalPrice }}</div>
                </div>

                <!-- <s-table ref="tables" :columns="registerTable" :data="loadData[index]" :rowKey="(record) => record.mediId">

                  <span slot="useType" slot-scope="text, record">
                    {{ record.useType + ',' + '一次' + record.wmOnceDosage + record.baseUnit + ',' + record.freq }}
                  </span>

                </s-table> -->
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </a-modal>
</template>

<script>
  import {STable} from '@/components'
  import {baPatientList, baRegisterList} from '@/api/modular/interhospital/bapatient/baPatientManage'

  export default {
    components: {
      STable
    },
    data() {
      return {
        labelCol: {xs: {span: 24}, sm: {span: 5}},
        wrapperCol: {xs: {span: 24}, sm: {span: 15}},
        birthdayDateString: '',
        createDateDateString: '',
        confirmLoading: false,
        visible: false,

        /**
         * 患者信息
         */
        userDate: [],
        visitList: [], // 就诊信息
        tabIndex: 0,

        /**
         * 处方详情参数
         */
        // presTab: ['处方信息', '检验单', '检查单'],
        presTab: ['处方信息'],
        activeIdx: 0,
        registerList: [],
      }
    },

    methods: {
      // 初始化方法
      add(record) {
        const {patientid} = record
        this.getPatient(patientid)
        this.visible = true
      },

      // 获取就诊人信息
      async getPatient(patientId) {
        const res = await baPatientList({patientId})
        console.log('res', res)

        this.userDate = res.data.baPaitentVO;
        this.visitList = res.data.details
        console.log("就诊信息：", this.visitList.length)

        if (res.data.details[0]) {
          this.getRegister(res.data.details[0].registerId, 0)
        }
      },

      // 获取处方信息
      async getRegister(registerId, index) {
        console.log(index)

        this.tabIndex = index;

        const res = await baRegisterList({registerId})
        if (res.data.resList) {
          this.registerList = res.data.resList
        } else {
          this.registerList = []
        }
      },

      // 点击tab函数
      clickItem(index) {
        console.log(index)
        this.activeIdx = index
      },

      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },

      onChangecreateDate(date, dateString) {
        this.createDateDateString = dateString
      },

      handleCancel() {
        this.visible = false
      }
    }
  }
</script>

<style lang="less">
  .full-modal {
    .ant-modal {
      max-width: 100%;
      top: 0;
      padding-bottom: 0;
      margin: 0;
    }

    .ant-modal-content {
      display: flex;
      flex-direction: column;
      min-height: calc(100vh);
    }

    .ant-modal-body {
      flex: 1;
    }
  }

  .viewDetial-title {
    height: 40px;
    line-height: 40px;
    font-family: "PingFang SC ", "PingFang SC", sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.847);
    margin-bottom: 10px;
  }

  /deep/ .s-table-tool {
    display: none;
  }

  .activeStyle {
    background-color: rgba(24, 144, 255, 1);
    color: white;
  }

  .tabActive {
    color: #1890FF;
  }

  .visitInfomation {
    display: flex;
    // padding: 20px;
    & > div {
      flex: 1;
    }

    .visitInfomation_speed {
      max-width: 200px;
      border: 1px solid rgba(242, 242, 242, 1);
      font-size: 12px;
      margin-right: 20px;

      & > ul {
        padding: 10px 0px 10px 25px;
      }

      & > ul > li {
        margin-bottom: 5px;
        list-style-type: circle;
        cursor: pointer;
      }
    }

    .visitInfomation_pres {
      .visitInfomation_pres_tab {
        height: 30px;
        /*width: 240px;*/
        width: 80px; /*modify 24.5.6*/
        display: flex;
        border: 1px solid rgba(24, 144, 255, 1);

        & > div {
          border-left: 1px solid rgba(24, 144, 255, 1);
          flex: 1;
          text-align: center;
          line-height: 30px;
          font-size: 13px;
          cursor: pointer;
        }

        & > div:first-child {
          border-left: 0px solid rgba(24, 144, 255, 1);
        }
      }

      .visitInfomation_pres_detial {
        border: 1px solid rgba(242, 242, 242, 1);
        padding: 15px;
      }

      .visitInfomation_pres_detial_list {
        & > div {
          border-bottom: 1px dotted #d7d7d7;
        }

        & > div:last-child {
          border-bottom: 0px;
        }
      }

      .imitateTable {
        border: 1px solid #f2f2f2;

        .imitateTable_title {
          display: flex;
          background-color: #f2f2f2;
          height: 30px;
          line-height: 30px;
          text-align: center;
          padding: 0 5px;

          & > div {
            flex: 1;
            min-width: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            border-bottom: 1px solid #f2f2f2;
          }
        }

        .imitateTable_item {
          display: flex;
          height: 30px;
          line-height: 30px;
          text-align: center;

          & > div {
            border-right: 1px solid #f2f2f2;
            flex: 1;
            min-width: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0 5px;
            border-bottom: 1px solid #f2f2f2;
          }

          & > div:last-child {
            border-right: 0px;
          }
        }

        .imitateTable_total {
          display: flex;
          height: 30px;
          line-height: 30px;
          text-align: center;

          & > div {
            border-right: 1px solid #f2f2f2;
            flex: 1;
            min-width: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0 5px;
          }

          & > div:last-child {
            border-right: 0px;
          }
        }
      }
    }

  }
</style>
